import { connect } from 'react-redux';
import {
  submitCountrySelection,
  udpateSiteId,
} from '@tcp/web/src/components/features/content/Header/molecules/CountrySelector/container/CountrySelector.actions.js'; // Adjust the path as necessary
import RedirectModal from '../views/RedirectModal'; // Adjust the path as necessary

export const mapDispatchToProps = (dispatch) => ({
  submitCountry: (payload) => dispatch(submitCountrySelection(payload)),
  updateSiteId: (payload) => dispatch(udpateSiteId(payload)),
});

export default connect(null, mapDispatchToProps)(RedirectModal);
